import http from '../http.js'
import { VIDEO_GENERATION_HISTORY_TASK_TYPES } from '../../constants/imageToVideoModels.js'

export const ImageToVideoApi = {
  CREATE_TASK: '/api/aigc/video/v1/video-generation/create-task',
  GET_TASK_RESULT: '/api/aigc/video/video-generation/get-task-result',
  GET_TASK_HISTORY: '/api/aigc/video/video-generation/get-history',
  DELETE_TASK: '/api/aigc/video/video-generation/delete-task',
}

/** @param {Record<string, unknown>} data */
export const createImageToVideoTask = (data) =>
  http.post(ImageToVideoApi.CREATE_TASK, data)

/** @param {{ task_id: string }} params */
export const getImageToVideoTaskResult = (params) =>
  http.get(ImageToVideoApi.GET_TASK_RESULT, params)

/** @param {{ page?: number, size?: number, task_type?: string }} params */
export const getImageToVideoTaskHistory = (params = {}) =>
  http.get(ImageToVideoApi.GET_TASK_HISTORY, {
    ...params,
    task_type: params.task_type || VIDEO_GENERATION_HISTORY_TASK_TYPES,
  })

/** @param {{ task_ids: string[] }} data */
export const deleteImageToVideoTask = (data) =>
  http.post(ImageToVideoApi.DELETE_TASK, data)
